import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2ShareRecommendationsQuery,
	StarterDashboardV2ShareRecommendationsQueryVariables,
} from './shareRecommendations.graphql';
import { StarterDashboardV2ShareRecommendations } from './shareRecommendations.graphql';

export type RootShareRecommendations = StarterDashboardV2ShareRecommendationsQuery['shareRecommendations'];
export type FacebookShareRecommendations =
	StarterDashboardV2ShareRecommendationsQuery['shareRecommendations']['facebook'];
export type RedditShareRecommendations = StarterDashboardV2ShareRecommendationsQuery['shareRecommendations']['reddit'];

export async function getShareRecommendations(
	utilityContext: UtilityContext,
	slug: string,
): Promise<RootShareRecommendations> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<
		StarterDashboardV2ShareRecommendationsQuery,
		StarterDashboardV2ShareRecommendationsQueryVariables
	>({
		query: StarterDashboardV2ShareRecommendations,
		variables: { slug },
		rejectOnError: true,
	});

	return data.shareRecommendations;
}
